"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Chevron.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Chevron = function Chevron(props) {
  return _react2.default.createElement("svg", Object.assign({
    viewBox: "0 0 300 120",
    className: "solid-icon"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Chevron Icon"), _react2.default.createElement("path", {
    d: "M298 2v116H2V2h296m2-2H0v120h300V0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M270.31 120H300V60.34L270.31 120zM300 60.28V0h-29.67L300 60.28zM200.95 60.31L171.25 120h43.22l29.76-59.81L214.61 0h-43.33l29.67 60.31zM101.89 60.31L72.2 120h43.21l29.76-59.81L115.55 0H72.22l29.67 60.31zM46.11 60.19L16.49 0H0v120h16.35l29.76-59.81z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }));
};
exports.default = Chevron;